import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};
const clientSnapshot = () => true;
const serverSnapshot = () => false;

/** Preserve SSR hydration while keeping client navigation ready on its first render. */
export const useClientReady = () => useSyncExternalStore(subscribe, clientSnapshot, serverSnapshot);
